export default {
  isVisible: () => {
    if (typeof localStorage !== 'undefined') {
      return !localStorage.getItem('mobile_prompt_closed');
    }
    return true; // Default to true if localStorage is not available
  },
  close: () => {
    if (typeof localStorage !== 'undefined') {
      localStorage.setItem('mobile_prompt_closed', 'true');
    }
  },
};
